const DEFAULT_KEY = 'files';

export const buildFormDataByArray = (files: File[], key = DEFAULT_KEY): FormData => {
  const formData = new FormData();
  files.forEach((file) => formData.append(key, file));
  return formData;
};

export const buildFormData = (file: File, key = DEFAULT_KEY): FormData => {
  return buildFormDataByArray([file], key);
};

export const buildFormDataByObject = (files: Record<string, File[]>, key = DEFAULT_KEY): FormData => {
  const allFiles = Object.values(files).flat();
  return buildFormDataByArray(allFiles, key);
};
